import './UserGuide.css'

import React from 'react'
import { MaterialSymbol } from 'react-material-symbols'

import { Button } from 'primereact/button'

import { useSplitViewContext } from '../../../../../contexts/splitView'
import { useUserGuideContext } from '../../../../../features/user-guide'

export const UserGuide: React.FC = () => {
  const { toggleUserGuide, isUserGuideOpen } = useUserGuideContext()
  const { setActiveSplitView } = useSplitViewContext()

  const handleToggle = () => {
    // If opening user guide, close E-Invoice preview
    if (!isUserGuideOpen) {
      setActiveSplitView(null)
    }
    toggleUserGuide()
  }

  return (
    <Button
      link
      aria-label="Open user guide"
      onClick={handleToggle}
      icon={<MaterialSymbol icon="help" size={24} />}
      className="header__user-guide__text-color p-2 border-none"
    />
  )
}
